var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomV2PlayBehaviorV4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20.0083 20.0083",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0042 11.3936V11.3936C9.77397 11.3936 9.58734 11.207 9.58734 10.9768V10.9768C9.58734 10.9 9.64955 10.8378 9.72629 10.8378H10.2821C10.3588 10.8378 10.421 10.9 10.421 10.9768V10.9768C10.421 11.207 10.2344 11.3936 10.0042 11.3936Z",
    stroke: "var(--stroke-0, #7A7670)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M15.0062 10.8378C15.0062 11.2983 15.3794 11.6715 15.8399 11.6715V11.6715C16.7607 11.6715 17.5072 10.925 17.5072 10.0041V7.50311C17.5072 6.12182 16.3875 5.00206 15.0062 5.00206H14.6586",
    stroke: "var(--stroke-0, #7A7670)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M6.71215 14.8781L5.83575 17.5072",
    stroke: "var(--stroke-0, #7A7670)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M13.2962 14.8781L14.1726 17.5072",
    stroke: "var(--stroke-0, #7A7670)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M5.34968 5.00206H5.00204C3.62075 5.00206 2.501 6.12182 2.501 7.50311V10.0041C2.501 10.925 3.2475 11.6715 4.16836 11.6715V11.6715C4.62879 11.6715 5.00204 11.2983 5.00204 10.8378",
    stroke: "var(--stroke-0, #7A7670)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M11.6715 14.8637V15.4231C11.6715 16.1137 11.1116 16.6736 10.421 16.6736H9.58729C8.89665 16.6736 8.33677 16.1137 8.33677 15.4231V14.8634",
    stroke: "var(--stroke-0, #7A7670)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0041 11.3936V12.5052C10.0041 13.8865 8.88434 15.0062 7.50306 15.0062V15.0062C6.12177 15.0062 5.00201 13.8865 5.00201 12.5052V6.6694C5.00201 4.36725 6.86827 2.501 9.17042 2.501H10.8378C13.1399 2.501 15.0062 4.36725 15.0062 6.6694V12.5052C15.0062 13.8865 13.8864 15.0062 12.5051 15.0062V15.0062C11.1239 15.0062 10.0041 13.8865 10.0041 12.5052V11.3936Z",
    stroke: "var(--stroke-0, #7A7670)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M14.1709 7.70425C13.8417 8.10841 13.3917 8.33758 12.9209 8.33758C12.4501 8.33758 12.0126 8.10841 11.6709 7.70425",
    stroke: "var(--stroke-0, #7A7670)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M8.3374 7.70425C8.00824 8.10841 7.55824 8.33758 7.0874 8.33758C6.61657 8.33758 6.17907 8.10841 5.8374 7.70425",
    stroke: "var(--stroke-0, #7A7670)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomV2PlayBehaviorV4);
export default __webpack_public_path__ + "static/media/customV2PlayBehaviorV4.b83a56c003b858f1566dd832c0471ff6.svg";
export { ForwardRef as ReactComponent };